function filterTypes(goodsName: string) {
    let firstSuitType: number = -1 // 第一个匹配上的大类(10是一个无意义的值)
    const simpleTypes: any[] = []
    const newTypes: any[] = []
    if (!goodsName) {
        return {
            simpleTypes,
            newTypes,
            firstSuitType: 0
        }
    }
    // 避免引用传递
    const allGoodsTypes = JSON.parse(JSON.stringify(goodsTypes))
    allGoodsTypes.shift()
    for (let i: number = 0; i < allGoodsTypes.length; i++) {
        const firstFloor = allGoodsTypes[i].children
        newTypes.push({
            typeName: allGoodsTypes[i].typeName,
            children: []
        })
        for (let m: number = 0; m < firstFloor.length; m++) {
            const secondFloor = firstFloor[m].children
            newTypes[i].children.push({
                typeName: firstFloor[m].typeName,
                children: []
            })
            for (let n: number = 0; n <= secondFloor.length - 1; n++) {
                if (goodsName.indexOf(secondFloor[n].name) > -1 || secondFloor[n].name.indexOf(goodsName) > -1) {
                    newTypes[i].children[m].children.push(secondFloor[n])
                    simpleTypes.push(secondFloor[n])
                    if (firstSuitType === -1) {
                        firstSuitType = i
                    }
                }
            }
        }
    }

    return {
        simpleTypes,
        newTypes,
        firstSuitType: firstSuitType === -1 ? 0 : firstSuitType
    }
}

const goodsTypes: any[] = [
    {
        typeName: '推荐',
        children: [
            {
                typeName: '推荐',
                children: []
            },
            {
                typeName: '最近选择',
                children: []
            }
        ]
    },
    {
        typeName: '水果',
        children: [
            {
                typeName: '仁果类',
                children: [
                    {
                        id: 1,
                        name: '梨',
                        img: 'Li'
                    },
                    {
                        id: 2,
                        name: '西瓜',
                        img: 'Xg'
                    },
                    {
                        id: 3,
                        name: '荔枝',
                        img: 'Lz'
                    },
                    {
                        id: 4,
                        name: '青苹果',
                        img: 'Qpg'
                    },
                    {
                        id: 5,
                        name: '苹果',
                        img: 'Pg'
                    },
                    {
                        id: 6,
                        name: '青梨',
                        img: 'Qli'
                    },
                    {
                        id: 7,
                        name: '榴莲',
                        img: 'Ll'
                    },
                    {
                        id: 8,
                        name: '哈密瓜',
                        img: 'Hmg'
                    },
                    {
                        id: 9,
                        name: '香瓜',
                        img: 'Xiangg'
                    },
                    {
                        id: 10,
                        name: '木瓜',
                        img: 'Mug'
                    },
                    {
                        id: 11,
                        name: '山楂',
                        img: 'Sz'
                    },
                    {
                        id: 12,
                        name: '桂圆',
                        img: 'Gy'
                    },
                    {
                        id: 13,
                        name: '枇杷',
                        img: 'Pp'
                    },
                    {
                        id: 14,
                        name: '山竹',
                        img: 'Shanzhu'
                    },
                    {
                        id: 15,
                        name: '释迦',
                        img: 'shijia'
                    },
                    {
                        id: 16,
                        name: '红毛丹',
                        img: 'hongmaodan'
                    },
                    {
                        id: 17,
                        name: '蛇果',
                        img: 'sheguo'
                    },
                    {
                        id: 18,
                        name: '加力果',
                        img: 'jialiguo'
                    },
                    {
                        id: 19,
                        name: '龙眼',
                        img: 'longyan'
                    },
                    {
                        id: 20,
                        name: '黄西瓜',
                        img: 'huangxigua'
                    },
                    {
                        id: 21,
                        name: '甜瓜',
                        img: 'tiangua'
                    }
                ]
            },
            {
                typeName: '核果类',
                children: [
                    {
                        id: 22,
                        name: '芒果',
                        img: 'Mg'
                    },
                    {
                        id: 23,
                        name: '水蜜桃',
                        img: 'Smt'
                    },
                    {
                        id: 24,
                        name: '黑布林',
                        img: 'Hbl'
                    },
                    {
                        id: 25,
                        name: '杨桃',
                        img: 'Yangt'
                    },
                    {
                        id: 26,
                        name: '樱桃',
                        img: 'yingtao'
                    },
                    {
                        id: 27,
                        name: '橄榄',
                        img: 'ganlan'
                    },
                    {
                        id: 28,
                        name: '油桃',
                        img: 'youtao'
                    },
                    {
                        id: 29,
                        name: '车厘子',
                        img: 'chelizhi'
                    },
                    {
                        id: 30,
                        name: '西梅',
                        img: 'ximei'
                    },
                    {
                        id: 31,
                        name: '杨梅',
                        img: 'yangmei'
                    },
                    {
                        id: 32,
                        name: '李子',
                        img: 'lizi'
                    },
                    {
                        id: 33,
                        name: '杏子',
                        img: 'xingzi'
                    },
                    {
                        id: 34,
                        name: '毛桃',
                        img: 'maotao'
                    },
                ]
            },
            {
                typeName: '坚果类',
                children: [
                    {
                        id: 35,
                        name: '腰果',
                        img: 'yaoguo'
                    },
                    {
                        id: 36,
                        name: '杏仁',
                        img: 'xingren'
                    },
                    {
                        id: 37,
                        name: '板栗',
                        img: 'banli'
                    },
                    {
                        id: 38,
                        name: '瓜子',
                        img: 'guazi'
                    },
                    {
                        id: 39,
                        name: '花生',
                        img: 'huasheng'
                    },
                    {
                        id: 40,
                        name: '开心果',
                        img: 'kaixinguo'
                    },
                    {
                        id: 41,
                        name: '松子',
                        img: 'sognzi'
                    },
                    {
                        id: 42,
                        name: '核桃',
                        img: 'hetao'
                    },
                    {
                        id: 43,
                        name: '葡萄干',
                        img: 'putaogan'
                    },
                    {
                        id: 44,
                        name: '红枣',
                        img: 'hongzao'
                    },
                    {
                        id: 45,
                        name: '巴旦木',
                        img: 'badanmu'
                    },
                    {
                        id: 46,
                        name: '蚕豆',
                        img: 'candou'
                    },
                    {
                        id: 47,
                        name: '豌豆',
                        img: 'wandou'
                    },
                    {
                        id: 48,
                        name: '夏威夷果',
                        img: 'xiaweiyiguo'
                    },
                    {
                        id: 49,
                        name: '柿饼',
                        img: 'shibing'
                    },
                    {
                        id: 50,
                        name: '碧根果',
                        img: 'bigenguo'
                    },
                    {
                        id: 51,
                        name: '香蕉片',
                        img: 'xiangjiaopian'
                    },
                    {
                        id: 52,
                        name: '甜角',
                        img: 'tianjiao'
                    },
                    {
                        id: 53,
                        name: '干桂圆',
                        img: 'ganguiyuan'
                    },
                    {
                        id: 54,
                        name: '榛子',
                        img: 'zhenzi'
                    },
                    {
                        id: 55,
                        name: '枸杞',
                        img: 'gouqi'
                    },
                    {
                        id: 56,
                        name: '杏干',
                        img: 'xinggan'
                    },
                    {
                        id: 57,
                        name: '无花果干',
                        img: 'wuhuaguogan'
                    },
                ]
            },
            {
                typeName: '浆果类',
                children: [
                    {
                        id: 58,
                        name: '葡萄',
                        img: 'Pt'
                    },
                    {
                        id: 59,
                        name: '青提',
                        img: 'Tz'
                    },
                    {
                        id: 60,
                        name: '猕猴桃',
                        img: 'Mht'
                    },
                    {
                        id: 61,
                        name: '石榴',
                        img: 'Sl'
                    },
                    {
                        id: 62,
                        name: '草莓',
                        img: 'Cm'
                    },
                    {
                        id: 63,
                        name: '百香果',
                        img: 'baixiangguo'
                    },
                    {
                        id: 64,
                        name: '红提',
                        img: 'hongti'
                    },
                    {
                        id: 65,
                        name: '蓝莓',
                        img: 'lanmei'
                    },
                    {
                        id: 66,
                        name: '人参果',
                        img: 'renshenguo'
                    },
                    {
                        id: 67,
                        name: '桑葚',
                        img: 'sangshen'
                    }
                ]
            },
            {
                typeName: '柑橘类',
                children: [
                    {
                        id: 68,
                        name: '小金橘',
                        img: 'Xjj'
                    },
                    {
                        id: 69,
                        name: '橘子',
                        img: 'Jz'
                    },
                    {
                        id: 70,
                        name: '小番茄',
                        img: 'Xfq'
                    },
                    {
                        id: 71,
                        name: '柠檬',
                        img: 'Nm'
                    },
                    {
                        id: 72,
                        name: '橙子',
                        img: 'Cz'
                    },
                    {
                        id: 73,
                        name: '柚子',
                        img: 'Yz'
                    },
                    {
                        id: 74,
                        name: '皇帝柑',
                        img: 'Hdg'
                    },
                    {
                        id: 75,
                        name: '西柚',
                        img: 'xiyou'
                    },
                    {
                        id: 76,
                        name: '丑八怪',
                        img: 'ugly'
                    }
                ]
            },
            {
                typeName: '热带及亚热带果类',
                children: [
                    {
                        id: 77,
                        name: '火龙果',
                        img: 'Hlg'
                    },
                    {
                        id: 78,
                        name: '香蕉',
                        img: 'Xj'
                    },
                    {
                        id: 79,
                        name: '椰子',
                        img: 'Yez'
                    },
                    {
                        id: 80,
                        name: '菠萝蜜',
                        img: 'Blm'
                    },
                    {
                        id: 81,
                        name: '菠萝',
                        img: 'Bl'
                    },
                    {
                        id: 82,
                        name: '莲雾',
                        img: 'lianwu'
                    },
                    {
                        id: 83,
                        name: '牛油果',
                        img: 'niuyouguo'
                    },
                    {
                        id: 84,
                        name: '凤梨',
                        img: 'fengli'
                    },
                    {
                        id: 85,
                        name: '皇帝蕉',
                        img: 'huangdijiao'
                    },
                    {
                        id: 86,
                        name: '番石榴',
                        img: 'fanshiliu'
                    }
                ]
            },
            {
                typeName: '什果类',
                children: [
                    {
                        id: 87,
                        name: '冬枣',
                        img: 'Dz'
                    },
                    {
                        id: 88,
                        name: '白地瓜',
                        img: 'Bdg'
                    },
                    {
                        id: 89,
                        name: '红枣',
                        img: 'hongzao'
                    },
                    {
                        id: 90,
                        name: '柿子',
                        img: 'Shiz'
                    },
                    {
                        id: 91,
                        name: '雪莲果',
                        img: 'Xlg'
                    },
                    {
                        id: 92,
                        name: '甘蔗',
                        img: 'Gz'
                    },
                    {
                        id: 93,
                        name: '无花果',
                        img: 'wuhuaguo'
                    },
                    {
                        id: 94,
                        name: '黄瓜',
                        img: 'huanggua'
                    }
                ]
            },
        ]
    },
    {
        typeName: '蔬菜蛋品',
        children: [
            {
                typeName: '叶菜类',
                children: [
                    {
                        id: 95,
                        name: '大白菜',
                        img: 'dabaicai'
                    },
                    {
                        id: 96,
                        name: '小白菜',
                        img: 'xiaobaicai'
                    },
                    {
                        id: 97,
                        name: '甘蓝',
                        img: 'ganlancai'
                    },
                    {
                        id: 98,
                        name: '生菜',
                        img: 'shengcai'
                    },
                    {
                        id: 99,
                        name: '菠菜',
                        img: 'bocai'
                    },
                    {
                        id: 100,
                        name: '韭菜',
                        img: 'jiucai'
                    },
                    {
                        id: 101,
                        name: '芹菜',
                        img: 'qincai'
                    },
                    {
                        id: 102,
                        name: '苦苣',
                        img: 'kuju'
                    },
                    {
                        id: 103,
                        name: '油麦菜',
                        img: 'youmaicai'
                    },
                    {
                        id: 104,
                        name: '秋葵',
                        img: 'qiukui'
                    },
                    {
                        id: 105,
                        name: '空心菜',
                        img: 'kongxincai'
                    },
                    {
                        id: 106,
                        name: '茼蒿',
                        img: 'tonghao'
                    },
                    {
                        id: 107,
                        name: '藜蒿',
                        img: 'lihao'
                    },
                    {
                        id: 108,
                        name: '苋菜',
                        img: 'xiancai'
                    },
                    {
                        id: 109,
                        name: '香菜',
                        img: 'xiangcai'
                    },
                    {
                        id: 110,
                        name: '茴香',
                        img: 'huixiang'
                    },
                    {
                        id: 111,
                        name: '香椿',
                        img: 'xiangchun'
                    },
                    {
                        id: 112,
                        name: '娃娃菜',
                        img: 'wawacai'
                    },
                    {
                        id: 113,
                        name: '芥兰',
                        img: 'jielan'
                    },
                    {
                        id: 114,
                        name: '荠菜',
                        img: 'jicai'
                    },
                    {
                        id: 115,
                        name: '马齿笕',
                        img: 'machixian'
                    },
                    {
                        id: 116,
                        name: '芥菜',
                        img: 'jiecai'
                    },
                    {
                        id: 117,
                        name: '雪里红',
                        img: 'xuelihong'
                    },
                    {
                        id: 118,
                        name: '紫苏',
                        img: 'zisu'
                    },
                    {
                        id: 119,
                        name: '菜苔',
                        img: 'caitai'
                    },
                ]
            },
            {
                typeName: '根茎类',
                children: [
                    {
                        id: 120,
                        name: '萝卜',
                        img: 'luobo'
                    },
                    {
                        id: 121,
                        name: '土豆',
                        img: 'tudou'
                    },
                    {
                        id: 122,
                        name: '蒜苔',
                        img: 'suantai'
                    },
                    {
                        id: 123,
                        name: '蒜头',
                        img: 'suan'
                    },
                    {
                        id: 124,
                        name: '姜',
                        img: 'jiang'
                    },
                    {
                        id: 125,
                        name: '葱',
                        img: 'cong'
                    },
                    {
                        id: 126,
                        name: '洋葱',
                        img: 'yangcong'
                    },
                    {
                        id: 127,
                        name: '莴苣',
                        img: 'woju'
                    },
                    {
                        id: 128,
                        name: '山药',
                        img: 'shanyao'
                    },
                    {
                        id: 129,
                        name: '马铃薯',
                        img: 'malingshu'
                    },
                    {
                        id: 130,
                        name: '红薯',
                        img: 'hongshu'
                    },
                    {
                        id: 131,
                        name: '卜留克',
                        img: 'buliuke'
                    },
                    {
                        id: 132,
                        name: '芦笋',
                        img: 'lusun'
                    },
                    {
                        id: 133,
                        name: '牛蒡',
                        img: 'niubang'
                    },
                    {
                        id: 134,
                        name: '藕',
                        img: 'ou'
                    }
                ]
            },
            {
                typeName: '果菜类',
                children: [
                    {
                        id: 135,
                        name: '辣椒',
                        img: 'lajiao'
                    },
                    {
                        id: 136,
                        name: '南瓜',
                        img: 'nangua'
                    },
                    {
                        id: 137,
                        name: '冬瓜',
                        img: 'donggua'
                    },
                    {
                        id: 138,
                        name: '苦瓜',
                        img: 'kugua'
                    },
                    {
                        id: 139,
                        name: '黄瓜',
                        img: 'huanggua'
                    },
                    {
                        id: 140,
                        name: '丝瓜',
                        img: 'sigua'
                    },
                    {
                        id: 141,
                        name: '佛手瓜',
                        img: 'foshougua'
                    },
                    {
                        id: 142,
                        name: '西葫芦',
                        img: 'xihulu'
                    },
                    {
                        id: 143,
                        name: '番茄',
                        img: 'fanqie'
                    },
                    {
                        id: 144,
                        name: '茄子',
                        img: 'qiezi'
                    },
                    {
                        id: 145,
                        name: '四季豆',
                        img: 'sijidou'
                    },
                    {
                        id: 146,
                        name: '豇豆',
                        img: 'jiangdou'
                    },
                    {
                        id: 147,
                        name: '豌豆',
                        img: 'wandou'
                    },
                    {
                        id: 148,
                        name: '架豆',
                        img: 'jiadou'
                    },
                    {
                        id: 149,
                        name: '刀豆',
                        img: 'daodou'
                    },
                    {
                        id: 150,
                        name: '扁豆',
                        img: 'biandou'
                    },
                    {
                        id: 151,
                        name: '菜豆',
                        img: 'caidou'
                    },
                    {
                        id: 152,
                        name: '毛豆',
                        img: 'maodou'
                    },
                    {
                        id: 153,
                        name: '蛇豆',
                        img: 'shedou'
                    },
                    {
                        id: 154,
                        name: '玉米',
                        img: 'yumi'
                    }
                ]
            },
            {
                typeName: '菌类',
                children: [
                    {
                        id: 155,
                        name: '木耳',
                        img: 'muer'
                    },
                    {
                        id: 156,
                        name: '银耳',
                        img: 'yiner'
                    },
                    {
                        id: 157,
                        name: '平菇',
                        img: 'pinggu'
                    },
                    {
                        id: 158,
                        name: '草菇',
                        img: 'caogu'
                    },
                    {
                        id: 159,
                        name: '金针菇',
                        img: 'jinzhengu'
                    },
                    {
                        id: 160,
                        name: '香菇',
                        img: 'xianggu'
                    },
                    {
                        id: 161,
                        name: '海鲜菇',
                        img: 'haixiangu'
                    },
                    {
                        id: 162,
                        name: '茶树菇',
                        img: 'chashugu'
                    }
                ]
            },
            {
                typeName: '家禽豆制品',
                children: [
                    {
                        id: 163,
                        name: '鸡蛋',
                        img: 'jidan'
                    },
                    {
                        id: 164,
                        name: '香干',
                        img: 'xianggan'
                    },
                    {
                        id: 165,
                        name: '豆腐',
                        img: 'doufu'
                    },
                    {
                        id: 166,
                        name: '千张',
                        img: 'qianzhang'
                    }
                ]
            }
        ]
    },
    {
        typeName: '食品饮料',
        children: [
            {
                typeName: '零食',
                children: [
                    {
                        id: 167,
                        name: '方便面',
                        img: 'fangbianmian'
                    },
                    {
                        id: 168,
                        name: '锅巴',
                        img: 'guoba'
                    },
                    {
                        id: 169,
                        name: '爆米花',
                        img: 'baomihua'
                    },
                    {
                        id: 170,
                        name: '雪米饼',
                        img: 'xuemibing'
                    },
                    {
                        id: 171,
                        name: '薯片/薯条',
                        img: 'shupianshutiao'
                    },
                    {
                        id: 172,
                        name: '虾片/虾条',
                        img: 'xiapianxiatiao'
                    },
                    {
                        id: 173,
                        name: '海苔',
                        img: 'haitai'
                    },
                    {
                        id: 174,
                        name: '巧克力',
                        img: 'qiaokeli'
                    },
                    {
                        id: 175,
                        name: '糖果',
                        img: 'tangguo'
                    },
                    {
                        id: 176,
                        name: '果干',
                        img: 'guogan'
                    },
                    {
                        id: 177,
                        name: '蛋糕',
                        img: 'dangao'
                    },
                    {
                        id: 178,
                        name: '面包',
                        img: 'mianbao'
                    },
                    {
                        id: 179,
                        name: '饼干',
                        img: 'binggan'
                    },
                    {
                        id: 180,
                        name: '沙琪玛',
                        img: 'shaqima'
                    },
                    {
                        id: 181,
                        name: '辣条',
                        img: 'latiao'
                    },
                    {
                        id: 182,
                        name: '其他零食',
                        img: 'qitalingshi'
                    }
                ]
            },
            {
                typeName: '酒水饮料',
                children: [
                    {
                        id: 183,
                        name: '牛奶',
                        img: 'niunai'
                    },
                    {
                        id: 184,
                        name: '矿泉水',
                        img: 'chunjingshui'
                    },
                    {
                        id: 185,
                        name: '酸奶',
                        img: 'suannai'
                    },
                    {
                        id: 186,
                        name: '果汁',
                        img: 'guozhi'
                    },
                    {
                        id: 187,
                        name: '白酒',
                        img: 'baijiu'
                    },
                    {
                        id: 188,
                        name: '啤酒',
                        img: 'pijiu'
                    },
                    {
                        id: 189,
                        name: '黄酒',
                        img: 'huangjiu'
                    },
                    {
                        id: 190,
                        name: '其他饮料',
                        img: 'qitayinliao'
                    }
                ]
            },
            {
                typeName: '粮油调味',
                children: [
                    {
                        id: 191,
                        name: '米',
                        img: 'mi'
                    },
                    {
                        id: 192,
                        name: '面粉',
                        img: 'mianfen'
                    },
                    {
                        id: 193,
                        name: '面条',
                        img: 'miantiao'
                    },
                    {
                        id: 194,
                        name: '食用油',
                        img: 'shiyongyou'
                    },
                    {
                        id: 195,
                        name: '生抽',
                        img: 'shengchou'
                    },
                    {
                        id: 196,
                        name: '醋',
                        img: 'cu'
                    },
                    {
                        id: 197,
                        name: '食用糖',
                        img: 'shiyongtang'
                    },
                    {
                        id: 198,
                        name: '食用盐',
                        img: 'shiyongyan'
                    },
                    {
                        id: 199,
                        name: '其他调味品',
                        img: 'qitatiaoweipin'
                    }
                ]
            },
            {
                typeName: '其他副食',
                children: [
                    {
                        id: 200,
                        name: '香烟',
                        img: 'xiangyan'
                    }
                ]
            }
        ]
    },
    {
        typeName: '冷冻食品',
        children: [
            {
                typeName: '冷冻肉类',
                children: [
                    {
                        id: 201,
                        name: '猪肉',
                        img: 'zhurou'
                    },
                    {
                        id: 202,
                        name: '牛肉',
                        img: 'niurou'
                    },
                    {
                        id: 203,
                        name: '羊肉',
                        img: 'yangrou'
                    },
                    {
                        id: 204,
                        name: '鸡肉',
                        img: 'jirou'
                    },
                    {
                        id: 205,
                        name: '鸭肉',
                        img: 'yarou'
                    },
                    {
                        id: 206,
                        name: '鸡翅',
                        img: 'jichi'
                    },
                    {
                        id: 207,
                        name: '其他肉类',
                        img: 'qitaroulei'
                    }
                ]
            },
            {
                typeName: '海鲜水产',
                children: [
                    {
                        id: 208,
                        name: '虾',
                        img: 'xia'
                    },
                    {
                        id: 209,
                        name: '蟹',
                        img: 'xie'
                    },
                    {
                        id: 210,
                        name: '鱼',
                        img: 'yu'
                    },
                    {
                        id: 211,
                        name: '贝',
                        img: 'bei'
                    },
                    {
                        id: 212,
                        name: '其他水产',
                        img: 'qitashuichan'
                    }
                ]
            },
            {
                typeName: '冻食',
                children: [
                    {
                        id: 213,
                        name: '水饺',
                        img: 'shuijiao'
                    },
                    {
                        id: 214,
                        name: '汤圆',
                        img: 'tangyuan'
                    },
                    {
                        id: 215,
                        name: '馒头',
                        img: 'mantou'
                    },
                    {
                        id: 216,
                        name: '火锅丸料',
                        img: 'huoguowanliao'
                    },
                    {
                        id: 217,
                        name: '冰淇淋',
                        img: 'bingqiling'
                    },
                    {
                        id: 218,
                        name: '其他冻食',
                        img: 'qitadongshi'
                    }
                ]
            }
        ]
    },
    {
        typeName: '其他',
        children: [
            {
                typeName: '其他',
                children: [
                    {
                        id: 219,
                        name: '包装盒',
                        img: 'baozhuanghe'
                    },
                    {
                        id: 220,
                        name: '鲜花',
                        img: 'xianhua'
                    },
                    {
                        id: 221,
                        name: '快递费',
                        img: 'kuaidifei'
                    },
                    {
                        id: 222,
                        name: '果篮',
                        img: 'guolan'
                    }
                ]
            }
        ]
    }
]

export {
    goodsTypes,
    filterTypes
}
